import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$vfluxImages, _vm$vfluxImages2, _vm$vfluxImages3, _vm$gettingProducts$r, _vm$producer$skuAcron, _vm$addingRegionSub$f;
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.loading ? _c("div", {
    staticClass: "winery"
  }, [typeof _vm.producer.id === "undefined" ? _c("div", [_c("h1", [_vm._v("Oups !")]), _c("p", [_vm._v("Something went wrong !")])]) : _vm.readOnly && !_vm.isAdding ? _c("div", [_c("div", {
    staticClass: "content-centered large"
  }, [_c("return", {
    ref: "return",
    attrs: {
      label: _vm.returnParams.isHistoryBack ? null : _vm.returnParams.regionName,
      routeName: _vm.returnParams.routeName,
      query: _vm.returnParams.query,
      isHistoryBack: _vm.returnParams.isHistoryBack
    }
  }), _c("div", {
    staticClass: "container-centered small"
  }, [_c("h3", {
    attrs: {
      id: "producer-title"
    }
  }, [_vm._v(_vm._s(_vm.producer.name))]), _c("div", {
    attrs: {
      id: "producer-description"
    },
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.producer.description))
    }
  }), _c("div", {
    attrs: {
      id: "producer-content"
    }
  }, [!_vm.mapFailedLoading ? _c("div", [_c("div", {
    attrs: {
      id: "container-map"
    }
  }, [_c("div", [_c("Map", {
    attrs: {
      types: ["vineyard"],
      address: _vm.producerAddress,
      guid: _vm.producer.guidMapbox
    },
    on: {
      mapFailedLoading: function mapFailedLoading($event) {
        _vm.mapFailedLoading = true;
      }
    }
  })], 1)])]) : _vm._e(), _c("div", {
    attrs: {
      id: "producer-img-container"
    }
  }, [_c("div", {
    attrs: {
      id: "producer-img"
    }
  }, [_c("vue-flux", {
    ref: "slider",
    attrs: {
      options: _vm.vfOptions,
      images: _vm.vfluxImages,
      transitions: ((_vm$vfluxImages = _vm.vfluxImages) === null || _vm$vfluxImages === void 0 ? void 0 : _vm$vfluxImages.length) > 1 ? _vm.vfTransitions : []
    },
    scopedSlots: _vm._u([((_vm$vfluxImages2 = _vm.vfluxImages) === null || _vm$vfluxImages2 === void 0 ? void 0 : _vm$vfluxImages2.length) > 1 ? {
      key: "controls",
      fn: function fn() {
        return [_c("flux-controls")];
      },
      proxy: true
    } : null, ((_vm$vfluxImages3 = _vm.vfluxImages) === null || _vm$vfluxImages3 === void 0 ? void 0 : _vm$vfluxImages3.length) > 1 ? {
      key: "pagination",
      fn: function fn() {
        return [_c("flux-pagination")];
      },
      proxy: true
    } : null], null, true)
  })], 1)])]), _c("TargetSelectors", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      thirdPartyContainerClass: "mt-4"
    },
    on: {
      changeThirdPartyUserSelected: _vm.fetchAllProducts,
      changePricePostingSelected: _vm.fetchAllProducts
    }
  }), _vm.gettingProducts.isPending ? _c("div", {
    staticClass: "mt-6 b-15 text-left"
  }, [_c("div", {
    staticClass: "text-smaller text-italic mb-4"
  }, [_vm._v("Loading products")]), _c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  })], 1) : ((_vm$gettingProducts$r = _vm.gettingProducts.results) === null || _vm$gettingProducts$r === void 0 ? void 0 : _vm$gettingProducts$r.length) == 0 ? _c("div", {
    staticClass: "text-left text-red text-bold mt-6 mb-15"
  }, [_vm._v(" No product, or an error occurred during the loading of the data ")]) : _c("div", {
    staticClass: "wine-list"
  }, _vm._l(_vm.gettingProducts.results, function (wine) {
    return _c("WineCard", {
      key: "".concat(wine.id_wine, "_").concat(wine.customerPriceEuro),
      attrs: {
        wineProp: wine,
        isAddingToCart: _vm.isAddingToCart,
        loggedUserData: _vm.loggedUserData
      },
      on: {
        changeQuantityOrder: _vm.changeQuantityOrder,
        addItemToCart: _vm.addItemToCart
      }
    });
  }), 1)], 1), _vm.canManage ? [_c("div", {
    staticClass: "text-center text-bold mt-6"
  }, [_vm.producer.isExcludedWineSearcher ? _c("span", {
    staticClass: "text-red"
  }, [_vm._v(" Products are excluded for wine-searcher catalogs ")]) : _c("span", [_vm._v("Products are included for wine-searcher catalogs")])]), _c("div", {
    staticClass: "text-center text-bold mt-6"
  }, [_vm.producer.isDefaultTastingPhotoRequired ? _c("span", {
    staticClass: "text-red"
  }, [_vm._v(" Products require by default a tasting photo ")]) : _c("span", [_vm._v("Products don't require by default a tasting photo")])]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openAttachedFilesDrawer();
      }
    }
  }, [_vm._v(" Attached files ")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.callToUpdate();
      }
    }
  }, [_vm._v("Edit")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.deleteProducer(_vm.producer.name);
      }
    }
  }, [_vm._v(" Delete ")])], 1)] : _vm._e()], 2)]) : _vm.canManage ? _c("div", {
    attrs: {
      id: "edit-container"
    }
  }, [_c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered small"
  }, [_vm.isAdding ? _c("h1", [_vm._v(_vm._s("Create a ".concat(_vm.labelProducer)))]) : _c("h1", [_vm._v(_vm._s("Edit the ".concat(_vm.labelProducer)))]), _c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c("section", {
    staticClass: "edit-form-container"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      cols: "12",
      md: "6"
    }
  }, [_c("h2", [_vm._v("Public information")]), _c("div", [_c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      placeholder: "Domaine Roger Belland",
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.producer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.producer, "name", $$v);
      },
      expression: "producer.name"
    }
  })], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Description",
      value: "Informations about the ".concat(_vm.labelProducer, "."),
      "hide-details": "auto",
      rules: [_vm.formRules.mustNotBeEmpty]
    },
    model: {
      value: _vm.producer.description,
      callback: function callback($$v) {
        _vm.$set(_vm.producer, "description", $$v);
      },
      expression: "producer.description"
    }
  })], 1)])]), _c(VCol, {
    attrs: {
      cols: "12",
      md: "6"
    }
  }, [_c("h2", [_vm._v("Configuration")]), _c("div", [_c("div", [_c("div", {
    staticClass: "flex items-baseline gap-3"
  }, [_c("div", {
    staticClass: "flex-grow"
  }, [_c(VTextField, {
    ref: "skuAcronym",
    staticClass: "required",
    attrs: {
      label: "SKU acronym",
      placeholder: "ACYM",
      maxlength: "20",
      disabled: !!_vm.producer.id && !_vm.skuManual,
      "hide-details": "auto",
      rules: [_vm.formRules.mustBeAlphanumeric]
    },
    on: {
      keyup: function keyup($event) {
        _vm.checkingSkuAcronymUnicity.result = null;
      }
    },
    model: {
      value: _vm.producer.skuAcronym,
      callback: function callback($$v) {
        _vm.$set(_vm.producer, "skuAcronym", $$v);
      },
      expression: "producer.skuAcronym"
    }
  }), _vm.checkingSkuAcronymUnicity.result === false ? _c("div", {
    staticClass: "text-left mt-1 text-smaller-2 text-danger"
  }, [_vm._v(" This SKU acronym is already used ")]) : _vm._e()], 1), _vm.producer.id ? _c("div", [!_vm.skuManual ? _c(VIcon, {
    attrs: {
      color: "black",
      title: "Edit",
      size: "0.85rem"
    },
    on: {
      click: _vm.toggleSkuManual
    }
  }, [_vm._v(" fa-pen ")]) : _c(VIcon, {
    attrs: {
      color: "black",
      title: "Back to initial",
      size: "0.85rem"
    },
    on: {
      click: _vm.toggleSkuManual
    }
  }, [_vm._v(" fa-undo ")])], 1) : _vm._e(), _c("div", [_vm.isAdding || !_vm.isAdding && _vm.skuManual ? [_vm.checkingSkuAcronymUnicity.result === true || !_vm.isAdding && _vm.producer.skuAcronym === _vm.skuAcronymOriginal ? _c(VIcon, {
    staticClass: "fa fa-check success",
    attrs: {
      size: "0.65rem"
    }
  }) : _vm.checkingSkuAcronymUnicity.result === false ? _c(VIcon, {
    staticClass: "fa fa-exclamation-triangle danger",
    attrs: {
      size: "0.85rem"
    }
  }) : ((_vm$producer$skuAcron = _vm.producer.skuAcronym) === null || _vm$producer$skuAcron === void 0 ? void 0 : _vm$producer$skuAcron.length) > 0 ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 warning",
    attrs: {
      rounded: "",
      loading: _vm.checkingSkuAcronymUnicity.isPending
    },
    on: {
      click: _vm.checkSkuAcronymUnicity
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-question cursor--pointer",
    attrs: {
      size: "0.65rem"
    }
  })], 1) : _vm._e()] : _vm._e()], 2)]), _vm.producer.id && _vm.skuManual ? _c("div", {
    staticClass: "errorLabel"
  }, [_c(VIcon, [_vm._v("fa-exclamation-triangle")]), _vm._v(" If you change the SKU acronym, all products and stocks associated will be automatically updated. You must notify the warehouses about this change. "), _c(VIcon, [_vm._v("fa-exclamation-triangle")])], 1) : _vm._e()]), _c("div", {
    staticClass: "mt-4"
  }, [_c(VAutocomplete, {
    staticClass: "required mt-4",
    attrs: {
      items: _vm.productTypeRefs,
      "hide-no-data": "",
      "item-text": "name",
      "item-value": "id",
      label: "Product types",
      required: true,
      "hide-details": "auto",
      multiple: "",
      rules: [_vm.formRules.mustSelectValue]
    },
    on: {
      change: _vm.updateProductTypes
    },
    model: {
      value: _vm.productTypes,
      callback: function callback($$v) {
        _vm.productTypes = $$v;
      },
      expression: "productTypes"
    }
  })], 1), _c("div", {
    staticClass: "text-left text-smaller mt-4"
  }, [_c("div", {
    staticClass: "text-smaller"
  }, [_c("span", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Beverage region(s)")]), _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" (they will be automatically updated with the regions selected on its products) ")])]), _vm.producer.regionSubs.length > 0 ? _c("div", _vm._l(_vm.producer.regionSubs, function (regionSub, index) {
    var _vm$producer$regionSu;
    return _c("div", {
      key: "regionSub-" + index
    }, [_c("div", {
      class: index > 0 ? ["mt-1"] : []
    }, [_vm._v(" " + _vm._s("".concat(regionSub.regionParent.country.printable_name, " / ")) + " " + _vm._s(regionSub.name != regionSub.regionParent.name ? "".concat(regionSub.regionParent.name, " - ") : "") + " " + _vm._s(regionSub.name) + " "), _c("span", {
      staticClass: "text-smaller text-italic"
    }, [_vm._v(" " + _vm._s(" (".concat(regionSub.regionParent.isSpiritRegion ? "spirits" : "wines", ")")) + " ")]), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary ml-2",
      attrs: {
        disabled: ((_vm$producer$regionSu = _vm.producer.regionSubs) === null || _vm$producer$regionSu === void 0 ? void 0 : _vm$producer$regionSu.length) < 2,
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.removeBeverageRegion(regionSub);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-trash mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Remove ")], 1)], 1)]);
  }), 0) : _vm._e(), _c("div", {
    staticClass: "mt-1"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openNewBeverageRegion();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add new beverage region ")], 1)], 1), _vm.addingRegionSub.isOpen ? _c("div", {
    staticClass: "mt-2 pb-5 px-5 mb-3",
    staticStyle: {
      "border-left": "1px #dadada solid",
      "border-bottom": "1px #dadada solid"
    }
  }, [_c("div", {
    staticClass: "flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      to: _vm.toRegions(),
      target: "_blank"
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-cogs mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Manage regions and subregions ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      loading: _vm.refreshingRegions.isPending
    },
    on: {
      click: _vm.refreshRegions
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-sync-alt",
    attrs: {
      size: "0.65rem"
    }
  })], 1)], 1), _c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.regions,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "displayName",
      "return-object": "",
      label: "Region",
      placeholder: "Burgundy",
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingRegionSub.form.regionParent,
      callback: function callback($$v) {
        _vm.$set(_vm.addingRegionSub.form, "regionParent", $$v);
      },
      expression: "addingRegionSub.form.regionParent"
    }
  })], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: (_vm$addingRegionSub$f = _vm.addingRegionSub.form.regionParent) === null || _vm$addingRegionSub$f === void 0 ? void 0 : _vm$addingRegionSub$f.subRegions,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "return-object": "",
      label: "Beverage region",
      placeholder: "Côte de nuits",
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingRegionSub.form.regionSub,
      callback: function callback($$v) {
        _vm.$set(_vm.addingRegionSub.form, "regionSub", $$v);
      },
      expression: "addingRegionSub.form.regionSub"
    }
  })], 1), _c("div", {
    staticClass: "flex items-center mt-small"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancelNewBeverageRegion();
      }
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: true,
      disabled: !_vm.addingRegionSub.form.regionSub.id
    },
    on: {
      click: function click($event) {
        return _vm.addBeverageRegion();
      }
    }
  }, [_vm._v(" Add ")])], 1)]) : _vm._e()]), _c("div", {
    staticClass: "mt-4"
  }, [_c(VTextField, {
    attrs: {
      label: "Logistic email",
      placeholder: "winery@domain.com",
      "hide-details": "auto",
      rules: [_vm.formRules.notRequiredEmail]
    },
    model: {
      value: _vm.producer.logisticEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.producer, "logisticEmail", $$v);
      },
      expression: "producer.logisticEmail"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Contact last name",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.dbSupplierAssociated.contactLastname,
      callback: function callback($$v) {
        _vm.$set(_vm.dbSupplierAssociated, "contactLastname", $$v);
      },
      expression: "dbSupplierAssociated.contactLastname"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Contact first name",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.dbSupplierAssociated.contactFirstname,
      callback: function callback($$v) {
        _vm.$set(_vm.dbSupplierAssociated, "contactFirstname", $$v);
      },
      expression: "dbSupplierAssociated.contactFirstname"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Phone",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.dbSupplierAssociated.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.dbSupplierAssociated, "phone", $$v);
      },
      expression: "dbSupplierAssociated.phone"
    }
  }), _c(VSelect, {
    staticClass: "required",
    attrs: {
      items: _vm.listTerms,
      "item-value": "id",
      "item-text": "name",
      placeholder: "Select a payment terms",
      label: "Preferred terms",
      required: "",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.dbSupplierAssociated.terms,
      callback: function callback($$v) {
        _vm.$set(_vm.dbSupplierAssociated, "terms", $$v);
      },
      expression: "dbSupplierAssociated.terms"
    }
  }), _c(VSelect, {
    attrs: {
      items: _vm.listPaymentMethods,
      "item-value": "value",
      "item-text": "label",
      label: "Preferred payment method",
      required: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.dbSupplierAssociated.paymentMethod,
      callback: function callback($$v) {
        _vm.$set(_vm.dbSupplierAssociated, "paymentMethod", $$v);
      },
      expression: "dbSupplierAssociated.paymentMethod"
    }
  })], 1), _c("div", {
    staticClass: "d-flex align-center mt-4 text-smaller"
  }, [_c(VSwitch, {
    staticClass: "mt-0 mr-1",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.producer.isExcludedWineSearcher,
      callback: function callback($$v) {
        _vm.$set(_vm.producer, "isExcludedWineSearcher", $$v);
      },
      expression: "producer.isExcludedWineSearcher"
    }
  }), _vm.producer.isExcludedWineSearcher ? _c("span", {
    staticClass: "text-red"
  }, [_vm._v(" Products are EXCLUDED for the wine-searcher catalogs ")]) : _c("span", [_vm._v("Products are included for the wine-searcher catalogs")])], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c("div", {
    staticClass: "d-flex align-center mt-4 text-smaller"
  }, [_c(VSwitch, {
    staticClass: "mt-0 mr-1",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.producer.isDefaultTastingPhotoRequired,
      callback: function callback($$v) {
        _vm.$set(_vm.producer, "isDefaultTastingPhotoRequired", $$v);
      },
      expression: "producer.isDefaultTastingPhotoRequired"
    }
  }), _vm.producer.isDefaultTastingPhotoRequired ? _c("span", {
    staticClass: "text-green"
  }, [_vm._v(" New products require by default a TASTING PHOTO ")]) : _c("span", [_vm._v("New products don't require by default a tasting photo")])], 1), !_vm.isAdding && _vm.initDefaultTastingPhotoRequired !== _vm.producer.isDefaultTastingPhotoRequired ? _c(VCheckbox, {
    staticClass: "pl-5 mt-1",
    staticStyle: {
      width: "fit-content"
    },
    attrs: {
      label: "Apply this new tasting photo configuration to all of associated products",
      "hide-details": "auto"
    },
    model: {
      value: _vm.applyNewDefaultTastingPhotoRequired,
      callback: function callback($$v) {
        _vm.applyNewDefaultTastingPhotoRequired = $$v;
      },
      expression: "applyNewDefaultTastingPhotoRequired"
    }
  }) : _vm._e()], 1)])]), _c(VCol, {
    attrs: {
      cols: "12",
      md: "6"
    }
  }, [_c("h2", [_vm._v("Main address")]), _c("div", [_c("Address", {
    ref: "address",
    attrs: {
      baseModel: _vm.producer.address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: false,
      typeDisplayError: "rules"
    }
  })], 1)])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      cols: "12",
      md: "12"
    }
  }, [_c("ProducerStorageAddresses", {
    staticClass: "full",
    attrs: {
      id: _vm.producer.id,
      items: _vm.producer.alternativeStorageAddresses,
      countries: _vm.listCountries,
      states: _vm.listStates
    },
    on: {
      save: _vm.saveStorageAddresses
    }
  })], 1)], 1)], 1)]), !_vm.isUserBuyerGroup(_vm.loggedUserData) && !_vm.isHolding(_vm.loggedUserData) ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        _vm.imagesDrawer = !_vm.imagesDrawer;
      }
    }
  }, [_vm._v(" Manage images ")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true,
      disabled: !_vm.isProducerValid
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(!_vm.producer.id ? "Create" : "Save") + " ")])], 1) : _vm._e()], 1)])]) : _vm._e(), _vm.canManage ? _c(VNavigationDrawer, {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDrawer,
      expression: "clickOutsideDrawer"
    }],
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: "35%",
      temporary: ""
    },
    model: {
      value: _vm.imagesDrawer,
      callback: function callback($$v) {
        _vm.imagesDrawer = $$v;
      },
      expression: "imagesDrawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("div", {
    staticClass: "drawer-section"
  }, [_c("div", {
    staticClass: "drawer-section-title"
  }, [_vm._v("Image exploring the regions")]), _c("p", {
    staticClass: "font-italic"
  }, [_vm._v("Landscape orientation. Size; 650x430px Format JPEG")]), _vm.gettingImages.isPending ? _c(VSkeletonLoader, {
    attrs: {
      "max-height": "5rem",
      type: "image"
    }
  }) : [_c("div", {
    staticClass: "drawer-file-list"
  }, [!_vm.producerImages.mainImg ? _c("p", {
    staticClass: "flex text-sm text-center"
  }, [_vm._v("No image yet")]) : _c(VChip, {
    key: _vm.producerImages.mainImg,
    staticClass: "drawer-file-chip",
    attrs: {
      close: ""
    },
    on: {
      click: function click($event) {
        return _vm.openImageUrl(_vm.producerImages.mainImg);
      },
      "click:close": function clickClose($event) {
        return _vm.removeMainImage(_vm.producerImages.mainImg);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      left: ""
    }
  }, [_vm._v("mdi-cloud-download")]), _vm._v(" Image exploring the regions ")], 1)], 1)], _c("UploaderV2", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.producerImages.mainImg,
      expression: "!producerImages.mainImg"
    }],
    ref: "mainUploader",
    attrs: {
      url: _vm.uploadMainUrl,
      multiple: false,
      idInput: "file-upload-1",
      required: true,
      fileTypes: [".jpg", ".png"],
      label: "Attach producer images",
      hideUploadButton: ""
    },
    on: {
      uploaderContainsFile: _vm.updateUploaderStatus,
      "click:upload": _vm.syncUpload
    }
  }), !_vm.producerImages.mainImg && _vm.producer.id && this.isMainUploaderContainsFile ? _c(VBtn, {
    staticClass: "dfwa-btn--secondary upload-btn",
    on: {
      click: _vm.uploadMain
    }
  }, [_vm._v(" Upload ")]) : _vm._e()], 2), _c("section", {
    staticClass: "drawer-section"
  }, [_c("div", {
    staticClass: "drawer-section-title"
  }, [_vm._v("Slider images, on the producer page")]), _c("p", {
    staticClass: "font-italic"
  }, [_vm._v(" Free orientation. For each dimensition. Minimum 600px, Maximum 1500px. Format JPEG ")]), _vm.gettingImages.isPending ? _c(VSkeletonLoader, {
    attrs: {
      "max-height": "5rem",
      type: "image"
    }
  }) : [_c("div", {
    staticClass: "drawer-file-list"
  }, [!_vm.producerImages.secondaryImg.length ? _c("p", {
    staticClass: "flex text-sm text-center"
  }, [_vm._v(" No images yet ")]) : _vm._e(), _vm._l(_vm.producerImages.secondaryImg, function (image, index) {
    return _c(VChip, {
      key: index,
      staticClass: "drawer-file-chip",
      attrs: {
        close: ""
      },
      on: {
        click: function click($event) {
          return _vm.openImageUrl(image);
        },
        "click:close": function clickClose($event) {
          return _vm.removeSecondaryImage(index, image);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        left: ""
      }
    }, [_vm._v("mdi-cloud-download")]), _vm._v(" Slider image N°" + _vm._s(index + 1) + " ")], 1);
  })], 2)], _c("UploaderV2", {
    ref: "sliderUploader",
    attrs: {
      url: _vm.uploadSecondaryUrl,
      multiple: true,
      hideUploadButton: "",
      idInput: "file-upload-2",
      fileTypes: [".jpg", ".png"],
      label: "Attach images"
    },
    on: {
      "click:upload": _vm.uploadSecondaryAcknowledge
    }
  }), _vm.producer.id ? _c(VBtn, {
    staticClass: "dfwa-btn--secondary upload-btn",
    on: {
      click: _vm.uploadSecondary
    }
  }, [_vm._v(" Upload ")]) : _vm._e()], 2)])]) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("WineStockListModal", {
    key: _vm.wineStockKey,
    ref: "WineStockListModal",
    attrs: {
      wine: _vm.currentWine,
      quantity: _vm.currentQuantity,
      casingId: _vm.casingIdSelected,
      add: _vm.addItemToCart,
      isBasket: true
    },
    on: {
      closed: _vm.closeWineStockListModal
    }
  }) : _vm._e(), _vm.canManage && _vm.producer.id ? _c("ProducerAttachedFilesDrawer", {
    ref: "producerAttachedFileDrawerRef",
    attrs: {
      id: _vm.producer.id
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };